<template>
  <v-dialog persistent v-model="dialogIsActive" max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        color="primary"
        rounded
        small
      >
        <v-icon left>mdi-plus</v-icon>
        Ajouter un titre
      </v-btn>
    </template>

    <v-card>
      <v-card-title>Ajout d'un titre</v-card-title>

      <v-card-text>
        <v-form ref="form" @submit.prevent>
          <v-text-field
            :label="jobType === 'ENS' ? 'Dénomination précise' : 'Dénomination / spécialité'"
            v-model="degree.name"
            :rules="rules.name"
            validate-on-blur
            filled
          ></v-text-field>

          <v-menu
            ref="pickerMenu"
            v-model="pickerMenuIsActive"
            :close-on-content-click="false"
            transition="scale-transition"
            min-width="auto"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                label="Date de délivrance"
                :value="degree.date | formatDate"
                :rules="rules.date"
                filled
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>

            <v-date-picker
              ref="picker"
              v-model="degree.date"
              :max="new Date().toISOString().substr(0, 10)"
              min="1968-01-01"
              @change="saveBirth"
              no-title
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>

          <v-text-field
            label="Etablissement"
            v-model="degree.establishment"
            :rules="rules.establishment"
            validate-on-blur
            filled
          ></v-text-field>

          <v-file-input
            label="Copie du diplôme"
            v-model="degree.file"
            :rules="rules.file"
            filled
            prepend-icon=""
            append-icon="mdi-paperclip"
            hint="La copie du diplôme doit être au format PDF"
            persistent-hint
          ></v-file-input>

          <v-checkbox
            v-if="jobType === 'ENS'"
            label="Je dispose de l'expérience utile (MFP)"
            v-model="degree.mfp"
            hide-details
          ></v-checkbox>

          <v-checkbox
            label="Il s'agit d'un diplôme étranger"
            v-model="degree.isForeign"
            hide-details
          ></v-checkbox>

          <v-radio-group v-if="degree.isForeign" v-model="degree.hasEquivalence" mandatory>
            <template v-slot:label>
              Possédez-vous l'équivalence ?
            </template>
            <v-radio
              label="Oui"
              :value="true"
            ></v-radio>

            <v-file-input
              v-if="degree.hasEquivalence"
              label="Copie de l'équivalence"
              v-model="degree.equivalence"
              :rules="rules.file"
              filled
              prepend-icon=""
              append-icon="mdi-paperclip"
              hint="La copie de l'équivalence doit être au format PDF"
              persistent-hint
            ></v-file-input>

            <v-radio
              label="Non, je dois donc en faire la demande"
              :value="false"
            ></v-radio>
          </v-radio-group>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn text @click="close">Annuler</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="addDegree">Ajouter</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DegreeForm',

  props: {
    jobType: String,
  },

  data: () => ({
    pickerMenuIsActive: false,
    dialogIsActive: false,
    rules: {
      name: [(v) => !!v || 'Ce champs est obligatoire'],
      date: [(v) => !!v || 'Ce champs est obligatoire'],
      establishment: [(v) => !!v || 'Ce champs est obligatoire'],
      file: [
        (v) => !v || v.type === 'application/pdf' || 'Le document doit être au format PDF',
        (v) => !v || v.size > 0 || 'Le document ne peut pas être vide',
        (v) => !v || v.size < 25000000 || 'Le document doit faire moins de 25 MB',
      ],
    },
    degree: {
      name: '',
      date: '',
      establishment: '',
      file: null,
      mfp: false,
      isForeign: false,
      hasEquivalence: false,
      equivalence: null,
    },
  }),

  methods: {
    addDegree() {
      if (!this.$refs.form.validate()) return;
      this.$emit('adding-degree', this.degree);
      this.close();
    },
    close() {
      this.$refs.form.reset();
      this.dialogIsActive = false;
    },
    saveBirth(date) {
      this.$refs.pickerMenu.save(date);
    },
  },

  watch: {
    // eslint-disable-next-line object-shorthand
    'degree.isForeign'(newVal) {
      if (newVal) this.degree.hasEquivalence = true;
      else this.degree.hasEquivalence = false;
    },
    // eslint-disable-next-line object-shorthand
    'degree.hasEquivalence'(newVal) {
      if (!newVal) this.degree.equivalence = null;
    },
    pickerMenuIsActive(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.picker.activePicker = 'YEAR';
        });
      }
    },
  },
};
</script>
